"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.IpRange = exports.Cidr = exports.Ipv6Address = exports.Ipv4Address = exports.IpAddress = exports.IPV6_BYTE_COUNT = exports.IPV6_PART_COUNT = exports.IPV4_BYTE_COUNT = exports.IPV4_PART_COUNT = void 0;
var byte_array_utils_1 = require("./byte-array-utils");
var ip_notation_utils_1 = require("./ip-notation-utils");
var ip_parse_utils_1 = require("./ip-parse-utils");
exports.IPV4_PART_COUNT = 4;
exports.IPV4_BYTE_COUNT = 4;
exports.IPV6_PART_COUNT = 8;
exports.IPV6_BYTE_COUNT = 16;
var IpAddress = /** @class */ (function () {
    function IpAddress(bytes) {
        this.bytes = bytes.slice(0);
    }
    IpAddress.of = function (ip) {
        return ip_parse_utils_1.IpParseUtils.fromString(ip);
    };
    IpAddress.fromByteArray = function (bytes) {
        return ip_parse_utils_1.IpParseUtils.fromByteArray(bytes);
    };
    IpAddress.prototype.toByteArray = function () {
        return this.bytes.slice(0);
    };
    IpAddress.prototype.next = function () {
        return IpAddress.fromByteArray(byte_array_utils_1.ByteArrayUtils.plusOne(this.toByteArray()));
    };
    IpAddress.prototype.prev = function () {
        return IpAddress.fromByteArray(byte_array_utils_1.ByteArrayUtils.minusOne(this.toByteArray()));
    };
    IpAddress.prototype.compareTo = function (other) {
        if (this.version() !== other.version()) {
            throw new Error('Only IpAddresses of the same version can be compared');
        }
        return byte_array_utils_1.ByteArrayUtils.compare(this.bytes, other.bytes);
    };
    IpAddress.prototype.toString = function () {
        return this.shortNotation();
    };
    return IpAddress;
}());
exports.IpAddress = IpAddress;
var Ipv4Address = /** @class */ (function (_super) {
    __extends(Ipv4Address, _super);
    function Ipv4Address(bytes) {
        return _super.call(this, bytes) || this;
    }
    Ipv4Address.prototype.version = function () {
        return '4';
    };
    Ipv4Address.prototype.regularNotation = function () {
        return ip_notation_utils_1.IpNotationUtils.regularNotationV4(this.bytes);
    };
    Ipv4Address.prototype.shortNotation = function () {
        return ip_notation_utils_1.IpNotationUtils.shortNotationV4(this.bytes);
    };
    Ipv4Address.prototype.fullNotation = function () {
        return ip_notation_utils_1.IpNotationUtils.fullNotationV4(this.bytes);
    };
    return Ipv4Address;
}(IpAddress));
exports.Ipv4Address = Ipv4Address;
var Ipv6Address = /** @class */ (function (_super) {
    __extends(Ipv6Address, _super);
    function Ipv6Address(bytes) {
        return _super.call(this, bytes) || this;
    }
    Ipv6Address.prototype.version = function () {
        return '6';
    };
    Ipv6Address.prototype.regularNotation = function () {
        return ip_notation_utils_1.IpNotationUtils.regularNotationV6(this.bytes);
    };
    Ipv6Address.prototype.shortNotation = function () {
        return ip_notation_utils_1.IpNotationUtils.shortNotationV6(this.bytes);
    };
    Ipv6Address.prototype.fullNotation = function () {
        return ip_notation_utils_1.IpNotationUtils.fullNotationV6(this.bytes);
    };
    return Ipv6Address;
}(IpAddress));
exports.Ipv6Address = Ipv6Address;
var Cidr = /** @class */ (function () {
    function Cidr(prefix, prefixLen) {
        this.checkArgs(prefix, prefixLen);
        this.prefix = prefix;
        this.prefixLen = prefixLen;
    }
    Cidr.prototype.checkArgs = function (prefix, prefixLen) {
        if (!prefix) {
            throw new Error('prefix is required');
        }
        if (prefixLen === undefined || prefixLen === null) {
            throw new Error('prefix length is required');
        }
        if (prefix.version() == 'ipv4') {
            if (prefixLen < 0 || prefixLen > exports.IPV4_BYTE_COUNT * 8) {
                throw new Error('Invalid prefix length for IPv4');
            }
        }
        else {
            if (prefixLen < 0 || prefixLen > exports.IPV6_BYTE_COUNT * 8) {
                throw new Error('Invalid prefix length for IPv6');
            }
        }
    };
    Cidr.prototype.toString = function () {
        return this.prefix + "/" + this.prefixLen;
    };
    Cidr.prototype.toIpRange = function () {
        var startIpBytes = this.prefix.toByteArray();
        var endIpBytes = startIpBytes.slice(0);
        var masks = byte_array_utils_1.ByteArrayUtils.createMasks(startIpBytes.length, this.prefixLen);
        for (var i = 0; i < startIpBytes.length; ++i) {
            startIpBytes[i] = startIpBytes[i] & masks[i];
            endIpBytes[i] = endIpBytes[i] | (~masks[i] & 0xff);
        }
        return new IpRange(IpAddress.fromByteArray(startIpBytes), IpAddress.fromByteArray(endIpBytes));
    };
    return Cidr;
}());
exports.Cidr = Cidr;
var IpRange = /** @class */ (function () {
    function IpRange(startIpAddr, endIpAddr) {
        this.checkArgs(startIpAddr, endIpAddr);
        this.startIpAddr = startIpAddr;
        this.endIpAddr = endIpAddr;
    }
    IpRange.prototype.checkArgs = function (startIpAddr, endIpAddr) {
        if (!startIpAddr) {
            throw new Error('Start IP address is required');
        }
        if (!endIpAddr) {
            throw new Error('End IP address is required');
        }
        if (startIpAddr.version() !== endIpAddr.version()) {
            throw new Error('Start and end IP addresses must both be IPv4 or IPv6');
        }
        if (startIpAddr.compareTo(endIpAddr) > 0) {
            throw new Error('Start IP address must not be greater than end IP address');
        }
    };
    IpRange.prototype.toString = function () {
        return this.startIpAddr + " - " + this.endIpAddr;
    };
    IpRange.prototype.toCidrs = function () {
        var cidrs = new Array();
        var startIpBytes = this.startIpAddr.toByteArray();
        var endIpBytes = this.endIpAddr.toByteArray();
        var currIpBytes = startIpBytes;
        while (true) {
            var prefixLen = byte_array_utils_1.ByteArrayUtils.findPrefixLengthOfMaxStartingCidr(currIpBytes, endIpBytes);
            var currCidr = new Cidr(IpAddress.fromByteArray(currIpBytes), prefixLen);
            cidrs.push(currCidr);
            var lastIpBytes = currCidr.toIpRange().endIpAddr.toByteArray();
            if (byte_array_utils_1.ByteArrayUtils.compare(lastIpBytes, endIpBytes) >= 0) {
                break;
            }
            currIpBytes = byte_array_utils_1.ByteArrayUtils.plusOne(lastIpBytes);
        }
        return cidrs;
    };
    return IpRange;
}());
exports.IpRange = IpRange;
